import { useState, useEffect } from 'react';


const getComputedValues = (value) => {
   const secondCounter = (value % 60) + '';
   const minuteCounter = Math.floor((value % 3600) / 60) + '';
   const hourCounter = Math.floor((value % (3600 * 24)) / 3600) + '';
   const daysCounter = Math.floor(value / (3600 * 24)) + '';

   const computedSecond = `${secondCounter.length === 1 ? 0 : ''}${secondCounter}`;
   const computedMinute = `${minuteCounter.length === 1 ? 0 : ''}${minuteCounter}`;
   const computedHour = `${hourCounter.length === 1 ? 0 : ''}${hourCounter}`;
   const computedDay = `${daysCounter.length === 1 ? 0 : ''}${daysCounter}`;

   return {
      seconds: computedSecond,
      minutes: computedMinute,
      hours: computedHour,
      days: computedDay,
   };
};

export const useTimer = (sec, onFinish) => {
   const [isActive, setIsActive] = useState(true);
   const [counter, setCounter] = useState({
      count: sec,
      ...getComputedValues(sec),
   });

   useEffect(() => {
      let interval;

      if (isActive) {
         interval = setInterval(() => {
            if (counter.count <= 1) {
               setIsActive(false);
               onFinish && onFinish();
            }

            const { seconds, minutes, hours, days } = getComputedValues(counter.count - 1);
            setCounter((prev) => ({
               ...prev,
               ...(prev.count >= 1 ? { count: prev.count - 1 } : {}),
               seconds,
               minutes,
               hours,
               days,
            }));
         }, 1000);
      }

      return () => clearInterval(interval);
   }, [isActive, counter, onFinish]);

   const pause = () => setIsActive(false);
   const resume = () => setIsActive(true);
   const reset = (input = undefined) => {
      let value = input !== undefined ? input.toFixed(0) : sec;
      const { seconds, minutes, hours, days } = getComputedValues(value);
      setCounter({ count: value, seconds, minutes, hours, days });
      setIsActive(true);
   };

   return {
      isActive,
      counter: counter.count,
      seconds: counter.seconds,
      minutes: counter.minutes,
      hours: counter.hours,
      days: counter.days,
      pause,
      resume,
      reset,
   };
};
